import { render, staticRenderFns } from "./AccessRecords.vue?vue&type=template&id=6d2fc0ac&scoped=true"
import script from "./AccessRecords.vue?vue&type=script&lang=js"
export * from "./AccessRecords.vue?vue&type=script&lang=js"
import style0 from "./AccessRecords.vue?vue&type=style&index=0&id=6d2fc0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2fc0ac",
  null
  
)

export default component.exports